import { render, staticRenderFns } from "./e-yes‑no-switch.vue?vue&type=template&id=3eaa74fb&scoped=true&lang=pug"
import script from "./e-yes‑no-switch.vue?vue&type=script&lang=js"
export * from "./e-yes‑no-switch.vue?vue&type=script&lang=js"
import style0 from "./e-yes‑no-switch.vue?vue&type=style&index=0&id=3eaa74fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaa74fb",
  null
  
)

export default component.exports